import { useState } from "react";

import api from "./api";
import { LinkProfile, LinkProfileCreate, LinkClickStats } from "../models";
import { useCallback } from "react";

export const useLinkProfile = () => {
  const [page, setPage] = useState<number>(1);

  const [loading, setLoading] = useState<boolean>(false);

  const [linkProfiles, setLinkProfiles] = useState<LinkProfile[]>([]);

  const getLinkProfiles = useCallback((storeId: string | null): Promise<LinkProfile[]> => {
    setLoading(true);
    const params = storeId ? { store_id: storeId } : {};

    return api
      .get<LinkProfile[]>(`v1/link_profile/`, { params })
      .then((response) => {
        setLinkProfiles(response.data);
        setLoading(false);
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch link profiles:", error);
        setLoading(false);
        return Promise.reject(error);
      });
  }, []);

  const fetchLinkProfile = useCallback((linkPath: string) => {
      if (!linkPath) {
        return Promise.reject(new Error("Link path is required"));
      }

      return api
        .get<LinkProfile>(`/v1/link_profile/${linkPath}/`)
        .then((response) => {
          return response.data;
        });
    }, []);

  const [getLoading, setGetLoading] = useState<boolean>(false);
  const getLinkProfile = useCallback((id: string): Promise<LinkProfile> => {
    if (!id) {
      return Promise.reject(new Error("Link profile ID is required"));
    }
    
    setGetLoading(true);
    return api
      .get<LinkProfile>(`/v1/link_profile/${id}/`)
      .then((response) => {
        setGetLoading(false);
        return response.data;
      })
      .catch((error) => {
        setGetLoading(false);
        return Promise.reject(error);
      });
  }, []);

  const addLinkProfile = useCallback(
    async (newLinkProfile: LinkProfileCreate) => {
      const response = await api.post("/v1/link_profile/", newLinkProfile);
      return response.data;
    },
    []
  );

  const updateLinkProfile = useCallback((linkProfile: LinkProfile) => {
    return api.put(`/v1/link_profile/${linkProfile.id}/`, linkProfile);
  }, []);

  const linkProfileStats = useCallback(() => {
    return api
      .get<LinkClickStats>(`/v1/link_profile/stats`)
      .then((response) => {
        return response.data;
      });
  }, []);

  const linkProfileStatsDetail = useCallback((category: string) => {
    return api
      .get(`/v1/link_profile/details`, { params: { category } })
      .then((response) => {
        return response.data;
      });
  }, []);

  return {
    page,
    setPage,
    loading,
    getLoading,
    linkProfiles,
    getLinkProfiles,
    fetchLinkProfile,
    getLinkProfile,
    addLinkProfile,
    updateLinkProfile,
    linkProfileStats,
    linkProfileStatsDetail,
  };
};
